import { useMemo } from 'react';
import JSON_DATA_HEADER from '../data/header.json';
export const useHeaderUnit = () => {
    return useMemo(() => JSON_DATA_HEADER, []);
};
